import { Button } from '@/components/ui/button';

/**
 * Row of result option buttons for a pairing (e.g. 1-0 / ½-½ / 0-1).
 * Shared by PairingRow (compact size) and PairingCard (full-width size).
 */
export function ResultButtons({
  tableNumber,
  currentResult,
  resultOptions,
  pendingResult,
  onSetResult,
  variant,
}: {
  tableNumber: number;
  currentResult: string | null;
  resultOptions: { value: string; label: string }[];
  pendingResult: boolean;
  onSetResult: (result: string) => void;
  variant: 'card' | 'row';
}) {
  const sizeClass =
    variant === 'card' ? 'h-8 flex-1 text-xs' : 'h-7 px-2 text-xs';
  return (
    <>
      {resultOptions.map((opt) => {
        const isActive = currentResult === opt.value;
        const showAmber = isActive && pendingResult;
        return (
          <Button
            key={opt.value}
            size="sm"
            variant={isActive ? 'default' : 'outline'}
            className={`${sizeClass} ${
              showAmber ? 'bg-amber-500 hover:bg-amber-600' : ''
            }`}
            data-testid={`result-button-${opt.value}-${tableNumber}`}
            onClick={() => onSetResult(opt.value)}
          >
            {opt.label}
          </Button>
        );
      })}
    </>
  );
}
